export default "__VITE_ASSET__DKakh1xy__"